<mat-card class="fd-qsa-data-detail__card-container">
  <mat-card-title class="fd-qsa-data-detail__card-title">Quadro Societário e Beneficiários Finais</mat-card-title>
  <div *ngFor="let group of groups" class="fd-qsa-data-detail__group">
    <div class="fd-qsa-data-detail__partner-type">{{ group.title }}</div>
    <div *ngFor="let row of group.rows" class="fd-qsa-data-detail__data_row">
      <div class="fd-qsa-data-detail__partner-line" fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="10px">
        <div fxFlex="15" fxFlex.sm="30" fxFlex.xs="100">
          <strong>{{ row.partner?.personType === 'J' ? 'CNPJ' : 'CPF' }}</strong>
          <div>
            <span>{{ row.partner?.document | cpfCnpj }}</span>
          </div>
        </div>
        <div fxFlex="25" fxFlex.sm="60" fxFlex.xs="100">
          <strong>{{ row.partner?.personType === 'J' ? 'Razão Social' : 'Nome' }}</strong>
          <div>
            <span>{{ row.partner?.personType === 'J' ? row.partner?.socialReason : row.partner?.name }}</span>
          </div>
        </div>
        <div fxFlex="15" fxFlex.sm="30" fxFlex.xs="100" *ngIf="row.partner?.openDate">
          <strong>Data de Abertura</strong>
          <div>
            <span>{{ row.partner?.openDate }}</span>
          </div>
        </div>
        <div fxFlex="15" fxFlex.sm="30" fxFlex.xs="100" *ngIf="row.partner?.personType === 'F' && row.partner?.birthDate">
          <strong>Data de Nascimento</strong>
          <div>
            <span>{{ row.partner?.birthDate }}</span>
          </div>
        </div>
        <div fxFlex="10" fxFlex.sm="30" fxFlex.xs="100">
          <strong>Participação</strong>
          <div>
            <span>{{ row.participation }}%</span>
          </div>
        </div>
        <div fxFlex="5" fxFlex.sm="30" fxFlex.xs="100" *ngIf="row.partner?.personType === 'F'">
          <strong>PEP</strong>
          <div>
            <span>{{ row.partner?.isPep ? 'Sim' : 'Não' }}</span>
          </div>
        </div>
      </div>
      <div
        *ngFor="let representative of row.representatives"
        class="fd-qsa-data-detail__representative-line"
        fxLayout="row wrap"
        fxLayout.xs="column"
        fxLayoutGap="10px"
      >
        <div fxFlex="15" fxFlex.sm="30" fxFlex.xs="100">
          <strong>CPF</strong>
          <div>
            <span>{{ representative.document | cpfCnpj }}</span>
          </div>
        </div>
        <div fxFlex="25" fxFlex.sm="60" fxFlex.xs="100">
          <strong>Representante Legal</strong>
          <div>
            <span>{{ representative.name }}</span>
          </div>
        </div>
        <div fxFlex="15" fxFlex.sm="30" fxFlex.xs="100" *ngIf="representative.birthDate">
          <strong>Data de Nascimento</strong>
          <div>
            <span>{{ representative.birthDate }}</span>
          </div>
        </div>
        <div fxFlex="5" fxFlex.sm="30" fxFlex.xs="100">
          <strong>PEP</strong>
          <div>
            <span>{{ representative.isPep ? 'Sim' : 'Não' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
